import "./WhyChooseUs.css";

import {
    FaTruck,
    FaLock,
    FaUndo,
    FaRobot
} from "react-icons/fa";

function WhyChooseUs() {

    const features = [

        {
            icon:<FaTruck/>,
            title:"Fast Delivery",
            desc:"Lightning fast delivery across India."
        },

        {
            icon:<FaLock/>,
            title:"Secure Payments",
            desc:"100% safe and encrypted checkout."
        },

        {
            icon:<FaUndo/>,
            title:"Easy Returns",
            desc:"Simple and hassle-free returns."
        },

        {
            icon:<FaRobot/>,
            title:"AI Shopping",
            desc:"Find products naturally with AI."
        }

    ];

    return (

        <section className="why-section">

            <div className="section-top">

                <h2>

                    Why ShopSphere?

                </h2>

                <p>

                    Everything you need for an amazing shopping experience.

                </p>

            </div>

            <div className="why-grid">

                {

                    features.map((item,index)=>(

                        <div
                            key={index}
                            className="why-card"
                        >

                            <div className="why-icon">

                                {item.icon}

                            </div>

                            <h3>

                                {item.title}

                            </h3>

                            <p>

                                {item.desc}

                            </p>

                        </div>

                    ))

                }

            </div>

        </section>

    );

}

export default WhyChooseUs;